import { HugeiconsIcon } from "@hugeicons/react";
import { SquareLock01Icon } from "@hugeicons-pro/core-stroke-rounded";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { ReactNode } from "react";

export const PermittedField = ({
  isPermitted,
  children
}: {
  isPermitted: boolean;
  children: ReactNode;
}) => {
  if (isPermitted) return children;
  return (
    <Tooltip>
      <TooltipTrigger className="cursor-pointer text-left">
        <HugeiconsIcon icon={SquareLock01Icon} size={32} className="-mb-1.5" />
      </TooltipTrigger>
      <TooltipContent className="rounded-lg z-[50] border border-alpha-40 bg-alpha-800 p-4 text-sm text-content-1000-inverted shadow-md">
        No permissions to view data
      </TooltipContent>
    </Tooltip>
  );
};
